import styled from 'styled-components';
import { NEUTRAL_200 } from 'visitor-ui-component-library/constants/WidgetColors';
const ConsentPromptWrapper = styled.div.withConfig({
  displayName: "ConsentPromptWrapper"
})(["padding:14px 16px;background:", ";"], ({
  $isSpotlight
}) => $isSpotlight ? NEUTRAL_200 : 'transparent');
export default ConsentPromptWrapper;